import React, { useState } from "react";
import CustomInput from "../components/CustomInput";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { toast } from "react-toastify";

const Forgotpassword = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.patch(`${base_url}admin/forget-password`, { email });
      console.log("Response:", response.data);
      toast.success(response.data.message || "Reset password link sent successfully!");
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Failed to send reset password link. Please try again.");
    }
  };

  return (
    <div className="py-5 bg-common-clr" style={{ minHeight: "100vh" }}>
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="my-5 w-25 bg-white rounded-3 mx-auto p-4">
        <h3 className="text-center title">Forgot Password</h3>
        <p className="text-center">
          Please Enter your registered email to get a reset password mail.
        </p>
        <form onSubmit={handleSubmit}>
          <CustomInput
            type="email"
            label="Email Address"
            id="email"
            value={email}
            onChng={(e) => setEmail(e.target.value)}
          />

          <button
            className="border-0 px-3 py-2 text-white fw-bold w-100 bg-common-clr"
            type="submit"
          >
            Send Link
          </button>
        </form>
      </div>
    </div>
  );
};

export default Forgotpassword;